export enum ReportGrouping {
  ORDER = 'Order',
  SAMPLE = 'Sample'
}
